import {ICount} from '../report';

export interface IHMPSummarySchema {
    endDate: Date;
    startDate: Date;
    centers?: string[];
}

export interface IType {
    TYPE: string;
    [key: string]: string;
}

export interface IHmpSummary {
    generalDetails: IType[];
    rentMortgageAssist: IType[];
    country: IType[];
    courtReferralEvents: IType[];
    disposition: IType[];
    housingSubsidy: IType[];
    referredBy: IType[];
    referredTo: IType[];
}

export class HmpSummary implements IHmpSummary {
    generalDetails: IType[] = [];
    rentMortgageAssist: IType[] = [];
    country: IType[] = [];
    courtReferralEvents: IType[] = [];
    disposition: IType[] = [];
    housingSubsidy: IType[] = [];
    referredBy: IType[] = [];
    referredTo: IType[] = [];
}

export interface IHMPSummarySchemaResponse {
    center: string;
    openDate: string;
    title: string;
    centerCaseNumber: string;
    referralDate: string;
    disposition: string;
    agreementDate: string;
    mediationTotal: string;
    mediationDuringPeriod: string;
    referredByEntityName: string;
    referredByEntityType: string;
    referredToEntityName: string;
    referredToEntityType: string;
    nTQDate: string;
    isTenancyPreserved: string;
    moveOutDate: string;
    rentalAssistanceType: string;
    rentalAssistanceAmount: string;
    subsidyType: string;
    subsidyPreserved: string;
    participantScreened: string;
    participantRace: string;
    participantAge: string;
    participantGender: string;
    participantLanguage: string;
    participantMinorChildren: string;
    participantHouseHoldSize: string;
    landLoadScreened: string;
    landLoadRace: string;
    landLoadAge: string;
    landLoadGender: string;
    landLoadLanguage: string;
}

export interface ITenancyExtensions {
    _id: string;
    count: number;
    tenancyExtensions: {tenancyExtension: number}[];
    mean?: string | number;
    median?: string | number;
}

export interface IHmpSummaryData {
    closedActivities: ITenancyExtensions[];
    closedActivitiesWithoutClosedDate: ITenancyExtensions[];
    landlords: ITenancyExtensions[];
    tenants: ITenancyExtensions[];
    mediationSessions: ITenancyExtensions[];
    mediationHours: ITenancyExtensions[];
    mediationHoursExternalUsers: ITenancyExtensions[];
    adminHoursExternalUsers: ITenancyExtensions[];
    screenedActivities: ITenancyExtensions[];
    mediatedActivities: ITenancyExtensions[];
    agreements: ITenancyExtensions[];
    moveOuts: ITenancyExtensions[];
    additionalMoveOutTime: ICount[];
    tenancyExtensionMean: ICount[];
    tenancyExtensionMedian: ICount[];
    tenanciesPreserved: ICount[];
    rentMortgageAssist: ICenterAcronym[];
    courtReferralEvents: ICenterAcronym[];
    housingSubsidy: ICenterAcronym[];
    disposition: ICenterAcronym[];
    referrals: ICount[];
    totalCasesClosedTenancy: ICount[];
    totalCasesClosedTenancyAdditionalDaysGreaterThanZero: ITenancyExtensions[];
    subsidiesPreserved: ICount[];
    referredBy: ICenterAcronym[];
    referredTo: ICenterAcronym[];
    country: ICenterAcronym[];
}

export interface ICenterAcronym {
    _id: string;
    centerAcronym: {_id: string; count: number}[];
}

export interface IHMPSummaryFormattedData extends IHmpSummaryData {
    tenancyExtensionMean: ICount[];
    tenancyExtensionMedian: ICount[];
}
